<template>
  <div v-if="btnShow" class="OrderManageList-root">
    <div v-if="authority" class="operations-btns">
      <a-space>
        <a-dropdown>
          <a-menu slot="overlay" @click="handlePlaceOrder">
            <a-menu-item :key="PlaceOrderType.SINGLE">下单</a-menu-item>
            <a-menu-item :key="PlaceOrderType.MULTIPLE">批量导入下单</a-menu-item>
          </a-menu>
          <a-button
            v-auth="$_ButtonPermission.ORDER_ORDERONLINE"
            v-track-click="{ trackName: '订单-仓配订单-在线下单' }"
            type="primary"
          >
            在线下单
          </a-button>
        </a-dropdown>
      </a-space>
    </div>
    <div v-if="authority" class="search-pane">
      <a-tabs v-model="currentTab">
        <a-tab-pane v-for="tab in OrderProgressTabMap" :key="tab.key" :tab="tab.title" />
      </a-tabs>
      <pro-search
        ref="search"
        :open="openMore"
        :fileds="SearchFiled"
        :form="queryForm"
        @search="handleSerch"
        @reset="handleReset"
      >
        <template slot="orderType">
          <select-search
            v-if="orderStatusOptions.length > 0"
            ref="selectDom"
            :list="typeList"
            :current-tab="currentTabOrder"
            @onSearch="filterGoodsCategoryOptions"
            @checkedList="checkedList"
          >
          </select-search>
        </template>
        <template slot="serviceProvider">
          <serviceSelect
            ref="serviceSelect"
            :only-select="false"
            @change="handleChange"
          ></serviceSelect>
        </template>
        <template slot="warehouse">
          <select-dom
            v-model="queryForm.warehouse"
            :list="ProjectList"
            @onSearch="onSearchProject"
          />
        </template>
      </pro-search>
    </div>

    <div v-if="authority" class="table-content">
      <div class="activeStyle">
        <div>
          <a-button
            v-auth="$_ButtonPermission.WAREHOUSE_BATCH_CANCEL"
            :class="batchCancel"
            type="primary"
            :disabled="selectedOrders.length === 0"
            @click="cancelOrderMultiple"
          >
            批量取消
          </a-button>
        </div>
        <div>
          <a-button @click="handleExport"> 导出订单 </a-button>
        </div>
      </div>
      <a-table
        :columns="Colums"
        :data-source="orderList"
        :scroll="{ x: 'calc(700px + 50%)' }"
        class="table-multip"
        :loading="isLoadingTable"
        :pagination="pagination"
        :row-selection="{
          onSelect: handleRowSelect,
          onSelectAll: handleRowSelectAll,
          getCheckboxProps: rowSelect,
          onChange,
          selectedRowKeys: selectedRowKeys,
        }"
        @change="handleTableChange"
      >
        <!-- 订单号 -->
        <template slot="unifyOdrNo" slot-scope="text, rowData">
          <p class="textLine">
            <a @click="checkDetail(rowData)">{{ text }}</a>
          </p>
          <p v-if="rowData.crmNumber" class="fontstyle">
            <span class="wai">外</span>{{ rowData.crmNumber }}
          </p>
        </template>
        <!-- 订单状态 -->
        <template slot="status" slot-scope="text, rowData">
          <status-tag :type="filterTag(text)" :desc="rowData.expCalReason" :text="STATUSTEXT[text]"></status-tag>
          <a-tooltip v-if="rowData.projectName && sensitiveFields.includes('project')" placement="top">
            <template slot="title">
              <p>
                {{ rowData.projectName }}
              </p>
            </template>
            <p class="address-txt-min testStyle">
              {{ rowData.projectName }}
            </p>
          </a-tooltip>
        </template>
        <!-- 订单类型 -->
        <template slot="scene" slot-scope="text">
          <p>{{ filterScene(text) }}</p>
          <p class="testStyle">{{ filterTransport(text) }}</p>
        </template>
        <!-- 货品信息 -->
        <template slot="goosInfo" slot-scope="text, rowData">
          <p class="ellipsis">{{ filterGoods(rowData) }}</p>
          <p>{{ filterWidth(rowData) }}</p>
        </template>
        <template slot="unifyOrderGoodsListNum" slot-scope="text, rowData">
          <p class="ellipsis">{{ filterRealityGoods(rowData) || '--' }}</p>
          <p>{{ filterRealityWidth(rowData) }}</p>
        </template>
        <!-- 仓货主 -->
        <template slot="customerName" slot-scope="text, rowData">
          <!-- 仓配入库、仓配出库：显示货主名称 -->
          <!-- 调拨
          第一行：显示「发」icon和调出货主名称
          第二行：显示「收」icon和调入货主名称 -->
          <div v-if="rowData.ext && rowData.ext.demoData">**餐饮连锁</div>
          <div v-else-if="rowData.storeCustomerName && rowData.deliverCustomerName">
            <p><span class="tag">发</span>{{ rowData.deliverCustomerName || '' }}</p>
            <p>
              <span class="tag success">收</span>{{ rowData.storeCustomerName || '' }}
            </p>
          </div>
          <div v-else>
            {{ rowData.storeCustomerName || rowData.deliverCustomerName || '' }}
          </div>
        </template>
        <!-- 仓库 -->
        <template slot="warehouse" slot-scope="text, rowData">
          <p>{{ filterWarehouse(rowData) }}</p>
        </template>
        <!-- 运输地点 -->
        <template slot="startAddress" slot-scope="text, rowData">
          <div v-if="!rowData.orderMsgResList || rowData.orderMsgResList.length <= 0">
            <!-- {{ rowData.endStationName || rowData.startStationName || '--' }} -->
            <div v-if="rowData.endStationName" class="address-txt">
              <span class="endStyle"></span>
              <p>{{ rowData.endStationName || '' }}</p>
            </div>
            <div v-else-if="rowData.startStationName" class="address-txt">
              <span class="startStyle"></span>
              <p>{{ rowData.startStationName || '' }}</p>
            </div>
            <p v-else>--</p>
          </div>
          <div v-else>
            <a-tooltip placement="top">
              <template slot="title">
                <p>
                  {{
                    (rowData.orderMsgResList[0].consignorProvinceName || '') +
                    (rowData.orderMsgResList[0].consignorCityName || '') +
                    (rowData.orderMsgResList[0].consignorCountyName || '') +
                    (rowData.orderMsgResList[0].consignorAddress || '')
                  }}
                </p>
              </template>
              <div class="address-txt">
                <span class="startStyle"></span>
                <p>{{ rowData.startStationName || '--' }}</p>
              </div>
            </a-tooltip>
            <a-tooltip placement="top">
              <template slot="title">
                <template v-for="(address, i) in rowData.orderMsgResList">
                  <div :key="i">
                    <span>{{ getRecipientAddress(address) }}</span>
                  </div>
                </template>
              </template>
              <div class="address-txt">
                <span class="endStyle"></span>
                <p>
                  {{ rowData.endStationName || '--' }}
                  {{
                    rowData.orderMsgResList && rowData.orderMsgResList.length > 1
                      ? `等${rowData.orderMsgResList.length}个`
                      : ''
                  }}
                </p>
              </div>
            </a-tooltip>
          </div>
        </template>
        <!-- 订单总金额 -->
        <template slot="orderAmount" slot-scope="text, rowData">
          <span v-if="rowData.ifTransportCancel && rowData.ifWarehouseCancel">0.00</span>
          <span v-else-if="rowData.cost">{{ rowData.cost }}</span>
          <span
            v-else-if="
              rowData.needTransport &&
              rowData.cost !== null &&
              rowData.warehouseCost !== null
            "
          >
            {{ filterNumber(rowData.cost, rowData.warehouseCost) }}
          </span>
          <span v-else-if="!rowData.needTransport && rowData.warehouseCost !== null">
            {{ filterNumber(0, rowData.warehouseCost) }}
          </span>
          <span v-else class="order-amount">暂未计算</span>
        </template>
        <!-- 派车信息 -->
        <template slot="dispatchInfo" slot-scope="text, rowData">
          <span v-if="rowData.orderDispatchExtraList.length === 1">
            <p v-if="rowData.ext && rowData.ext.demoData">
              {{ rowData.orderDispatchExtraList[0].driverName.slice(0, 1) + '师傅' }}
              {{
                rowData.orderDispatchExtraList[0].driverPhone.slice(0, 3) +
                '****' +
                rowData.orderDispatchExtraList[0].driverPhone.slice(
                  rowData.orderDispatchExtraList[0].driverPhone.length - 4,
                  rowData.orderDispatchExtraList[0].driverPhone.length
                )
              }}
            </p>
            <p v-else>
              {{ rowData.orderDispatchExtraList[0].driverName }}
              {{ rowData.orderDispatchExtraList[0].driverPhone }}
            </p>
            <p>{{ rowData.orderDispatchExtraList[0].licensePlate }}</p>
          </span>
          <span v-else-if="rowData.orderDispatchExtraList.length == 1">
            共派车<a @click="checkCarInfo(rowData)">
              {{ rowData.orderDispatchExtraList.length }} </a
            >辆
          </span>
          <span v-else>--</span>
        </template>
        <!-- 下单信息 -->
        <template slot="createTime" slot-scope="text, rowData">
          <p>{{ rowData.createUserName }}</p>
          <span>{{ text }}</span>
        </template>
        <!-- 操作栏 -->
        <span slot="action" slot-scope="text, rowData">
          <template
            v-if="
              (!rowData.ext || !rowData.ext.demoData) &&
              rowData.status !== ORDERSTATUS.forCredit
            "
          >
            <a
              v-if="
                ((showEditButton(rowData.status, rowData.odrChannel, rowData) &&
                  !rowData.ifRefuseWaybill) ||
                  (isNowWaCustomer && rowData.status === ORDERSTATUS.toBeStore)) &&
                !rowData.ext.planCode
              "
              v-track-click="{ trackName: '仓配-编辑' }"
              v-auth="$_ButtonPermission.WAREHOUSE_EDIT"
              class="action-btn"
              type="link"
              @click="editOrder(rowData, false)"
            >
              编辑
            </a>
            <a
              v-track-click="{
                trackName: `订单-仓配订单-${
                  OrderProgressTabMap.find((t) => t.key === currentTab).title
                }-再来一单`,
              }"
              v-auth="$_ButtonPermission.WAREHOUSEORDER_AGAIN"
              class="action-btn"
              type="link"
              @click="editOrder(rowData, true)"
            >
              再来一单
            </a>
            <a
              v-if="showCancelButton(rowData) && !rowData.ifRefuseWaybill"
              v-track-click="{ trackName: '仓配-取消' }"
              v-auth="$_ButtonPermission.WAREHOUSE_CANCEL"
              class="action-btn removeStyle"
              type="link"
              @click="cancelOrder(rowData)"
            >
              取消
            </a>
          </template>
        </span>
      </a-table>
      <message-box
        v-if="messageFlag"
        :can-cancel-deliver="canCancelDeliver"
        :order-list="closeList"
        @onClose="onClose"
        @onUpdate="onUpdate"
      ></message-box>
    </div>
    <div v-else class="noAuthority">暂未对个人货主开放，敬请期待</div>
  </div>
</template>

<script>
import moment from 'moment';
import { EventBus } from '@/utils/event-bus';
import baseApi from '@/api/base.js';
import SelectDom from '@/components/select/SelectDom';
import StatusTag from '@/components/tag/StatusTag.vue';
import serviceSelect from '@/components/selectCarrier/serviceSelect.vue';
import ProSearch from '@/components/TableSearch/index.vue';
import { postTrack } from '@/utils/point';
import { mapState } from 'vuex';
import {
  fetchOrderList,
  cancelOrder,
  orderBatchDeletion,
  getWareHouse,
  getCustomerList,
  wareHouseOrderExport,
  getProjectList,
} from '../api';
import tableColums from './tableColums';
import {
  OrderStatusCode,
  OrderStatus,
  OrderProgressTabMap,
  DetailTabs,
  OrderTypeList,
  Transport,
  warehouseOrderTypeALL,
  warehouseOrderTypeDOING,
  warehouseOrderTypeFINISH,
  warehouseOrderTypeCANCEL,
  STATUSTEXT,
  SCENE,
  ORDERSTATUS,
  SearchFiled,
} from './constant';
import SelectSearch from './components/SelectSearch';
import MessageBox from './components/MessageBox';
import { getWareHouseContract, getConfig } from '../../orderManage/api.js';

const PlaceOrderType = {
  SINGLE: 'single', // 单个下单
  MULTIPLE: 'multiple', // 批量下单
};
// 订单状态 增加草稿，草稿状态可修改
const showStatus = ['DRAFT', 'SUBMITTED', 'EXP_CAL_STATUS', 'PRE_DRAFT'];
const showStatusCanCel = [
  'SUBMITTED',
  'EXP_CAL_STATUS',
  'DEAL',
  'DRAFT',
  'TO_BE_DELIVER',
  'DELIVERING',
  'TO_BE_STORE',
  'PRE_DRAFT',
  'FAIL_CREDIT',
];

const openApi = 14;
const cancanl = 9;

export default {
  name: 'OrderManageList',
  components: {
    SelectSearch,
    SelectDom,
    MessageBox,
    StatusTag,
    serviceSelect,
    ProSearch,
  },
  data() {
    return {
      STATUSTEXT,
      ORDERSTATUS,
      warehouseOrderTypeALL,
      Transport,
      selectedRowKeys: [],
      OrderStatusCode,
      OrderStatus,
      PlaceOrderType,
      OrderProgressTabMap,
      pageSize: 10,
      currentTab: OrderProgressTabMap[1].key,
      currentTabOrder: OrderProgressTabMap[1].key,
      orderRecords: [],
      goodsCategory: [],

      // 数据查询条件
      queryForm: {
        unifyOdrNo: '',
        crmNumber: '',
        status: '',
        createTime__BETWEEN: [],
        warehouse: '',
        needTransport: '',
        scene: '',
        createUserName: '',
        stationInfo: '',
        projectIds: '',
      },
      associationOdrNo: '', // 订单组同组查询:同组订单号
      selectedOrders: [], // 选中的订单
      pagination: {
        current: 1,
        total: 0,
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        onShowSizeChange: (current, pageSize) => {
          this.pageSize = pageSize;
        },
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      isLoadingTable: false,
      tabsValue: 'ALL',
      typeList: [],
      openMore: true,
      ProjectList: [
        {
          label: '全部',
          value: '',
        },
      ],
      accountData: {},
      authority: true,
      btnShow: false,
      selectAll: true,
      allProjectData: [],
      orderStatusOptions: [],
      cancelType: 2,
      messageFlag: false,
      OrderTypeList,
      warehouseFlag: false,
      closeList: [],
      canCancelDeliver: false, // 可只取消运输
      customerCodes: null,
      warehouseContract: true,
      isEnterprise: false,
      isDischarge: false, // 一装多卸白名单
      isNowWaCustomer: false, // nowwa咖啡白名单
    };
  },
  computed: {
    ...mapState('user', ['buttonPermission']),
    sensitiveFields() {
      return (
        this.$store.state.orderRules?.sensitiveFields?.SENSITIVE_FIELDS
          ?.orderSensitiveFields || []
      );
    },
    SearchFiled() {
      const arr = []
      SearchFiled.forEach(e => {
        if (!this.isEnterprise && e.name === 'serviceProvider') return
        if (e.name === 'projectIds' && !this.sensitiveFields.includes('project')) return
        if (e.name === 'serviceProvider' && !this.sensitiveFields.includes('providers')) return
        arr.push(e)
      })
      return arr;
    },
    // 表格数据
    orderList() {
      const orderList = this.orderRecords.map((item) => {
        // 处理货物信息数据
        // let goodsName = ''
        // let goodsSum = 0
        // let goodsUnit = ''
        // let goodsTotalWeight = 0
        // let goodsTotalVolume = 0
        // item.goods.forEach((goodsItem, index, goods) => {
        //   if (goods.length === 1) {
        //     goodsName = item.ext?.orderGoodsType === 0 ? '1个货品' : goods[0].skuName
        //     goodsSum = goods[0].skuSum
        //     goodsUnit = goods[0].skuUnit
        //     goodsTotalWeight = goods[0].weightTon
        //     goodsTotalVolume = goods[0].volume
        //   } else {
        //     goodsName = item.ext?.orderGoodsType === 0 ? `${goods.length}个货品` : `${goods[0].skuName}等`
        //     goodsSum += goodsItem.skuSum
        //     goodsUnit = '件'
        //     goodsTotalWeight += goodsItem.weightTon
        //     goodsTotalVolume += goodsItem.volume
        //   }
        // })

        // 处理派车信息数据
        const cars = item.dispatchList || [];
        const dispatchInfo = {
          firstLine: `${cars[0]?.driverName} ${cars[0]?.driverPhone}`,
          secondLine: cars[0]?.licensePlate,
          carsNum: cars.length,
        };
        return {
          ...item,
          key: item.unifyOdrNo,
          statusText: OrderStatus[item.status],
          // goodsInfoFistLine: `${ goodsName} 共${this.formatFloatNum(goodsSum)}${goodsUnit}`,
          // goodsInfoSecondLine: `共${this.formatFloatNum(goodsTotalWeight)}kg/${this.formatFloatNum(goodsTotalVolume)}M³`,
          createTime: moment(item.createTime).format('YYYY-MM-DD HH:mm:ss'),
          dispatchInfo,
        };
      });
      return orderList;
    },
    batchCancel() {
      // eslint-disable-next-line no-nested-ternary
      return this.tabsValue === 'FINISH'
        ? 'btn-cancel btnhidden'
        : this.tabsValue === 'CANCEL'
        ? 'btn-cancel btnoverhidden'
        : 'btn-cancel';
    },
    batchDelete() {
      return this.tabsValue === 'CANCEL' ? 'btn-cancel' : 'btn-cancel btnhidden';
    },
    Colums() {
      const cols = tableColums(this.isNowWaCustomer);
      const arr = [];
      cols.forEach(e => {
        if (e.dataIndex === 'carrierTenantName' && !this.sensitiveFields.includes('providers')) return
        if (e.dataIndex === 'cost' && !this.sensitiveFields.includes('order_amount')) return
        arr.push(e)
      })
      return arr
    },
  },
  watch: {
    async currentTab(newVal, oldVal) {
      postTrack(
        `订单-仓配订单-${OrderProgressTabMap.find((t) => t.key === newVal).title}`
      );
      this.tabsValue = newVal;
      if (newVal !== oldVal) {
        this.orderStatusOptions = await this.getOrderTypeList();
        this.currentTabOrder = newVal;
        // 切换tab时，需要清空查询数据
        this.initQueryForm();
        this.initPagination();
        this.selectedOrders = [];
        this.getOrderList();
        this.selectedRowKeys = [];
      }
    },
  },
  async created() {
    this.getProjectList();
    // const {creditCode}=this.$store.state.user
    // 获取到按钮权限再渲染页面
    await this.getConfigList();
    if (this.buttonPermission) {
      this.btnShow = true;
    }
    this.authority = this.$store.state.user.companyType;
    this.orderStatusOptions = await this.getOrderTypeList();
    await this.initQueryForm();
    await this.getCargoType();
    await this.getWarehouseMultiDischarge();
    const { creditCode } = this.$store.state.user;
    if (!creditCode) {
      await this.getCustomerList();
    }
    this.isEnterprise = !!creditCode;
    // if (!this.isEnterprise) {
    //   this.SearchFiled = this.SearchFiled.filter(
    //     (item) => item.name !== 'serviceProvider'
    //   );
    // }
    await this.getOrderList();
  },
  beforeRouteEnter(to, from, next) {
    next((mv) => {
      const forms = from;
      if (forms.path !== '/order/warehous-detail') {
        mv.initQueryForm();
        mv.initPagination();
        mv.getOrderList();
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  beforeDestroy() {},
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async getProjectList(code) {
      const { customerCode, customers } = this.$store.state.user;
      let customerCodes = [];
      if (code) {
        customerCodes = code;
      } else if (customers) {
        customerCodes = customers.map((item) => item.customerCode);
      } else {
        customerCodes = [customerCode];
      }
      const res = await getProjectList({
        customerCodes,
      });
      const options = res.map((item) => ({
        value: item.id,
        label: item.projectName,
      }));
      this.SearchFiled.map((item) => {
        if (item.name === 'projectIds') {
          item.prop.options = [
            {
              value: '',
              label: '全部',
            },
            ...options,
          ];
          item.prop.filterOption = this.filterOption;
        }
        return item;
      });
    },
    async getConfigList() {
      const res = await getConfig({
        appId: '1002',
        keys: ['oms.nowwa.white.list'],
      });
      const customerCode = this.$store.state.user?.customerCode;
      const whiteList = res.configs[0]?.value?.split(',') || [];
      this.isNowWaCustomer = whiteList.includes(customerCode);
    },
    async getWarehouseMultiDischarge() {
      const res = await getConfig({
        appId: '1004',
        keys: ['oms.warehouse.multi.discharge'],
      });
      // const customerCode = this.$store.state.user?.customerCode
      this.isDischarge = res.configs[0]?.value?.split(',');
    },
    async handleChange(value) {
      await this.getCustomerList();
      this.customerCodes = [value.customerCode];
      this.queryForm.carrierTenantName = value.carrierTenantName;
      this.queryForm.customerCode = value.customerCode;
      this.queryForm.warehouse = '';
      this.queryForm.projectIds = '';
      this.getOrderList();
      this.getProjectList(this.customerCodes);
    },
    async handleExport() {
      let reqData = this.filterEmptyKey(this.queryForm);
      let needTransport;
      if (reqData.needTransport === 1) {
        needTransport = true;
      } else if (reqData.needTransport === 0) {
        needTransport = false;
      }
      reqData = {
        queryField: {
          carrierTenantName: reqData.carrierTenantName,
          customerCode: reqData.customerCode,
          associationOdrNo: this.associationOdrNo,
          unifyNo: reqData.unifyOdrNo,
          crmNumber: reqData.crmNumber,
          skuName: reqData.skuName,
          needTransport,
          scene: reqData.scene,
          warehouseCode: reqData.warehouse,
          unifyStartTime: Number(reqData.createTime__BETWEEN[0]?.format('x')),
          unifyEndTime: Number(reqData.createTime__BETWEEN[1]?.format('x')),
          createUserName: reqData.createUserName,
          stationInfo: reqData.stationInfo,
          projectIds: reqData.projectIds ? [reqData.projectIds] : null,
        },
        status: reqData.status ? reqData.status.split(',') : '',
        sort: 'DESC',
      };
      await wareHouseOrderExport(reqData);
      EventBus.$emit('taskPopover');
    },
    filterTag(val) {
      if (
        val === ORDERSTATUS.expStatus ||
        val === ORDERSTATUS.preDraft ||
        val === ORDERSTATUS.failCredit
      ) {
        return 'err';
      }
      return '';
    },
    setcurrentTab() {
      this.currentTab = OrderProgressTabMap[1].key;
    },
    getRecipientAddress(station) {
      const address = station?.orderStationList?.[0] || {};
      return `${address.recipientProvinceName || ''}${address.recipientCityName || ''}${
        address.recipientCountyName || ''
      }${address.recipientAddress || ''}`;
    },
    async getCustomerList() {
      const { customerId } = this.$store.state.user;
      const data = {
        type: 'ORG',
        needCustomerInfo: true,
        needRelation: true,
        // carrierTenantId: this.$store.state.user.tenantId
      };
      data.identityIds = [customerId];
      const params = {
        page: 1,
        size: 200,
      };
      const res = await getCustomerList(data, params);
      const customerCodes = [];
      res.records.forEach((e) => {
        if (e.customerInfo && e.customerInfo.customerCode) {
          customerCodes.push(e.customerInfo.customerCode);
          if (e.childrenOrg && e.childrenOrg.length > 0) {
            e.childrenOrg.forEach((n) => {
              if (n.customerInfo?.customerCode) {
                customerCodes.push(n.customerInfo?.customerCode);
              }
            });
          }
        }
      });
      this.customerCodes = customerCodes;
      this.getWareHouse(customerCodes);
    },
    getWareHouse(customerCodes = null, tenantName = null) {
      const data = {
        customerCodes,
        tenantName,
        needExcludeDefaultTenant: true,
      };
      getWareHouse(data, { size: 500 }).then((res) => {
        if (res.length <= 0) {
          this.ProjectList = [];
          return;
        }
        const wareList = [];
        res.records.forEach((item) => {
          if (!wareList.some((child) => child.tenantId === item.tenantId)) {
            wareList.push(item);
          }
        });
        const arr = wareList.map((e) => {
          return {
            ...e,
            label: e.tenantName,
            value: e.tenantId,
          };
        });
        arr.unshift({
          label: '全部',
          value: '',
        });
        this.ProjectList = arr;
        if (!this.warehouseFlag) {
          this.allProjectData = arr;
          this.warehouseFlag = true;
        }
      });
    },
    onSearchProject(tenantName) {
      const { creditCode } = this.$store.state.user;
      if (tenantName || !creditCode) {
        this.getWareHouse(this.customerCodes, tenantName);
      }
    },
    filterWarehouse(data) {
      if (data.ext?.demoData) {
        return '运荔枝演示仓库';
      }
      if (data.deliverWarehouseName && data.storeWarehouseName) {
        return `${data.deliverWarehouseName} -> ${data.storeWarehouseName}`;
      }
      if (data.deliverWarehouseName) {
        return data.deliverWarehouseName;
      }
      if (data.storeWarehouseName) {
        return data.storeWarehouseName;
      }
      return '';
    },
    // 筛选订单类型
    filterScene(data = '') {
      let text = '';
      switch (data) {
        case SCENE.DELIVER_ONLY:
        case SCENE.DELIVER_TRANSPORT:
          text = '仓配出库';
          break;
        case SCENE.STORE_TRANSPORT:
        case SCENE.STORE_ONLY:
          text = '仓配入库';
          break;
        case SCENE.DELIVER_STORE:
          text = '仓内调拨';
          break;
        case SCENE.DELIVER_TRANSPORT_STORE:
          text = '仓间调拨';
          break;
        default:
          break;
      }

      return text;
    },
    filterTransport(data = '') {
      return data.includes('TRANSPORT') ? '' : '不含运输';
    },
    // 货品数量件数筛选
    filterGoods(data) {
      let goodsData = null;
      if (data.unifyOrderGoodsList && data.unifyOrderGoodsList.length > 0) {
        goodsData = data.unifyOrderGoodsList;
        const goodsList = [];
        goodsData.forEach((e) => {
          if (!goodsList.includes(e.skuCode)) {
            goodsList.push(e.skuCode);
          }
        });
        const goodsNumber = goodsList.length;
        let num = 0;
        goodsData.forEach((e) => {
          num += e.planAmount;
        });
        if (goodsNumber === 1) {
          return `${goodsNumber}个货品 共${num}${goodsData[0].skuUnit}`;
        }
        return `${goodsNumber}个货品 共${num}件`;
      }
      return '';
    },
    filterRealityGoods(data) {
      let goodsData = null;
      if (data.unifyOrderGoodsList && data.unifyOrderGoodsList.length > 0) {
        goodsData = data.unifyOrderGoodsList;
        const goodsList = [];
        goodsData.forEach((e) => {
          if (!goodsList.includes(e.skuCode)) {
            goodsList.push(e.skuCode);
          }
        });
        const goodsNumber = goodsList.length;
        let num = 0;
        let notNum = true;
        goodsData.forEach((e) => {
          if (
            (data.scene === SCENE.DELIVER_ONLY ||
              data.scene === SCENE.DELIVER_TRANSPORT) &&
            e.wmsExt &&
            e.wmsExt.deliver_finish_sum
          ) {
            notNum = false;
            num += e.wmsExt.deliver_finish_sum;
          } else if (
            (data.scene === SCENE.STORE_ONLY || data.scene === SCENE.STORE_TRANSPORT) &&
            e.wmsExt &&
            e.wmsExt.store_finish_sum
          ) {
            notNum = false;
            num += e.wmsExt.store_finish_sum;
          }
        });
        if (notNum) {
          return false;
        }
        if (goodsNumber === 1) {
          return `${goodsNumber}个货品 共${num}${goodsData[0].skuUnit}`;
        }
        return `${goodsNumber}个货品 共${num}件`;
      }
      return '';
    },
    // 货品体积数量筛选
    filterWidth(data) {
      let goodsData = null;
      if (data.unifyOrderGoodsList && data.unifyOrderGoodsList.length > 0) {
        goodsData = data.unifyOrderGoodsList;
      } else {
        return '';
      }
      let weightTon = 0;
      let volume = 0;
      goodsData.forEach((e) => {
        weightTon += e.planWeight;
        volume += e.planVolume;
      });
      return `共${this.formatFloatNum(weightTon)}kg/${this.formatFloatNum(volume)}M³`;
    },
    // 货品实际出入库体积数量筛选
    filterRealityWidth(data) {
      let goodsData = null;
      if (data.unifyOrderGoodsList && data.unifyOrderGoodsList.length > 0) {
        goodsData = data.unifyOrderGoodsList;
      } else {
        return '';
      }
      let weightTon = 0;
      let volume = 0;
      let notVolume = true;
      goodsData.forEach((e) => {
        if (
          (data.scene === SCENE.DELIVER_ONLY || data.scene === SCENE.DELIVER_TRANSPORT) &&
          e.wmsExt &&
          e.wmsExt.deliver_finish_sum
        ) {
          notVolume = false;
          weightTon += e.wmsExt.deliver_finish_weight;
          volume += e.wmsExt.deliver_finish_volume;
        } else if (
          (data.scene === SCENE.STORE_ONLY || data.scene === SCENE.STORE_TRANSPORT) &&
          e.wmsExt &&
          e.wmsExt.store_finish_sum
        ) {
          notVolume = false;
          weightTon += e.wmsExt.store_finish_weight;
          volume += e.wmsExt.store_finish_volume;
        }
      });
      return notVolume
        ? ''
        : `共${this.formatFloatNum(weightTon)}kg/${this.formatFloatNum(volume)}M³`;
    },
    filterNumber(cost, warehouseCost) {
      const num = cost * 1 + warehouseCost * 1;
      return num.toFixed(2);
    },
    async getOrderTypeList() {
      let options = [];
      switch (this.currentTab) {
        case 'ALL':
          options = warehouseOrderTypeALL;
          break;
        case 'DOING':
          options = warehouseOrderTypeDOING;
          break;
        case 'FINISH':
          options = warehouseOrderTypeFINISH;
          break;
        case 'CANCEL':
          options = warehouseOrderTypeCANCEL;
          break;
        default:
          break;
      }
      return options;
    },
    onChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    toSearch() {
      this.pagination.current = 1;
      this.handleSerch();
    },
    checkedList(data) {
      this.queryForm.status = data.length > 0 ? data.join(',') : '';
      this.getOrderList();
    },
    filterGoodsCategoryOptions(searchData) {
      if (searchData === '') {
        this.typeList = this.orderStatusOptions;
        return;
      }
      const arr = [];
      this.orderStatusOptions.forEach((e) => {
        if (e.label.includes(searchData)) {
          arr.push(e);
        }
      });
      this.typeList = arr;
    },
    searchType() {
      this.getCargoType();
    },
    showEditButton(status, odrChannel, row) {
      return (
        (showStatus.includes(status.toString()) && openApi !== odrChannel) ||
        (openApi === odrChannel &&
          status === 'PRE_DRAFT' &&
          row.scene !== SCENE.DELIVER_STORE &&
          row.scene !== SCENE.DELIVER_TRANSPORT_STORE)
      );
    },
    showCancelButton(rowData) {
      // // 待入库 没有运输可以取消
      // if(rowData.status === TO_BE_STORE && (!rowData.orderMsgResList || rowData.orderMsgResList.length <= 0)){
      //   return true
      // }
      return showStatusCanCel.includes(rowData.status.toString());
    },
    handleSerch(form) {
      this.initPagination();
      this.queryForm = {
        ...this.queryForm,
        ...form,
      };
      this.associationOdrNo = '';
      this.getOrderList();
    },
    handleReset() {
      this.initQueryForm();
      const { creditCode } = this.$store.state.user;
      if (creditCode) {
        this.$refs.serviceSelect.handleReset();
      }
      this.initPagination();
      this.getOrderList();
      this.$refs.selectDom.reseData(this.tabsValue);
      this.getProjectList();
    },
    handleRowSelect(record, selected, selectedRows) {
      this.selectedOrders = selectedRows;
    },
    rowSelect() {
      return {
        props: {
          disabled: this.tabsValue === 'FINISH',
        },
      };
    },
    handleRowSelectAll(selected, selectedRows) {
      this.selectedOrders = selectedRows;
    },
    async getContract(customerCode) {
      const warehouseContract = await getWareHouseContract({
        cargoOwnerCode: customerCode,
      });
      if (!warehouseContract.STORAGE || warehouseContract.STORAGE.length <= 0) {
        this.warehouseContract = false;
      }
    },
    async checkDetail(rowData) {
      // 获取仓合同
      await this.getContract(rowData.tenantId);
      this.$router.push({
        path: `/order/warehous-detail`,
        query: {
          unifyOdrNo: rowData.unifyOdrNo,
          warehouseContract: this.warehouseContract,
        },
      });
    },
    checkCarInfo(rowData) {
      this.$router.push({
        path: `/order/warehous-detail`,
        query: {
          unifyOdrNo: rowData.unifyOdrNo,
          detailTab: DetailTabs.CARINFO,
        },
      });
    },
    async editOrder(rowData, oneMoreOrder) {
      if (
        this.isDischarge.includes(rowData.tenantId) &&
        rowData.isWarehouseMultiDischargeOrder
      ) {
        // 如果当前订单是一装多卸订单,但是当前客户没有在一装多卸白名单之类
        this.$message.warning('操作仓配一装多卸订单需开通权限，请联系管理员处理');
        return;
      }
      // 获取仓合同
      await this.getContract(rowData.tenantId);
      if (!this.warehouseContract) {
        this.$message.warning('没有仓合同！');
        return;
      }
      if (oneMoreOrder) {
        this.$router.push({
          path: `/order/createOrder`,
          query: {
            customerCode: rowData.tenantId,
            odrNo: rowData.unifyOdrNo,
            productCode: 'warehouse',
            oneMoreOrder: true,
            type: 'warehouse',
            scene: rowData.scene
          },
        });
      } else {
        this.$router.push({
          // path: `/order/warehous-edit-single`,
          path: `/order/editOrder`,
          query: {
            customerCode: rowData.tenantId,
            odrNo: rowData.unifyOdrNo,
            productCode: 'warehouse',
          },
        });
      }
    },
    onClose() {
      this.messageFlag = false;
    },
    async onUpdate(type) {
      const res = await cancelOrder({
        cancelReason: '货主端取消',
        cancelType: type,
        unifyOdrNos: this.closeList,
      });
      try {
        const errList = JSON.parse(res);
        if (errList?.length) {
          if (this.closeList.length === 1) {
            this.$message.error(`取消失败，${errList.join('')}`);
          } else {
            this.getMessage(errList);
          }
        } else {
          this.$message.success('取消成功');
        }
      } catch {
        this.$message.success('取消成功');
      }
      this.messageFlag = false;
      this.selectedOrders = [];
      this.selectedRowKeys = [];
      this.getOrderList();
    },
    getErr(list) {
      return list.map((item) => {
        return <p>{item}</p>;
      });
    },
    getMessage(list) {
      this.$message.error({
        content: (
          <div>
            <p>{list.length}个订单取消失败</p>
            {this.getErr(list)}
          </div>
        ),
      });
    },
    // 订单单个取消
    cancelOrder(rowData) {
      this.closeList = [rowData.unifyOdrNo];
      let canCanl = true;
      if (
        rowData.status === ORDERSTATUS.draft ||
        rowData.status === ORDERSTATUS.submitted ||
        rowData.status === ORDERSTATUS.expStatus ||
        rowData.status === ORDERSTATUS.preDraft
      ) {
        canCanl = false;
      }
      // 没有运输
      if (!rowData.orderMsgResList || rowData.orderMsgResList.length <= 0) {
        canCanl = false;
      }
      // 运输订单，只取消了运输
      if (
        rowData.orderMsgResList &&
        rowData.orderMsgResList.length > 0 &&
        rowData.orderMsgResList[0].status === cancanl
      ) {
        canCanl = false;
      }
      // 一装多卸订单只能全部取消
      if (rowData.isWarehouseMultiDischargeOrder) {
        canCanl = false;
      }
      this.canCancelDeliver = canCanl;
      this.messageFlag = true;
    },
    // 订单批量取消
    cancelOrderMultiple() {
      this.closeList = this.selectedOrders.map((item) => item.unifyOdrNo);
      this.messageFlag = true;
      this.canCancelDeliver = false;
    },
    cancelOrderDelete() {
      const odrNos = this.selectedOrders.map((item) => item.unifyOdrNo);
      this.$confirm(`确定删除选中的${odrNos.length}个订单？`, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.onBatchDeletion({ odrNos });
          this.selectedOrders = [];
          this.selectedRowKeys = [];
        })
        .catch(() => {});
    },
    async onCancleOrders(odrNos) {
      await cancelOrder(odrNos);
      this.isLoadingTable = true;
      setTimeout(() => {
        this.$message.success(`${odrNos.length}个订单取消成功`);
        this.getOrderList();
      }, 1000);
    },
    async onBatchDeletion(odrNos) {
      const res = await orderBatchDeletion(odrNos);
      this.isLoadingTable = true;
      setTimeout(() => {
        this.$message.success(res);
        this.getOrderList();
      }, 2000);
    },
    handleTableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current,
      };
      this.selectedRowKeys = [];
      this.selectedOrders = [];
      this.getOrderList();
    },

    initPagination() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
    },
    initQueryForm() {
      let optionList = [];
      switch (this.currentTab) {
        case 'ALL':
          optionList = warehouseOrderTypeALL;
          break;
        case 'DOING':
          optionList = warehouseOrderTypeDOING;
          break;
        case 'FINISH':
          optionList = warehouseOrderTypeFINISH;
          break;
        case 'CANCEL':
          optionList = warehouseOrderTypeCANCEL;
          break;
        default:
          break;
      }
      const arr = optionList.map((e) => {
        return e.value;
      });
      const unifyOdrNo = arr.join(',');
      this.queryForm = {
        status: unifyOdrNo,
        unifyOdrNo: '',
        createTime__BETWEEN: [
          moment().subtract(30, 'days').startOf('day'),
          moment().endOf('day'),
        ],
        crmNumber: '',
        warehouse: '',
        needTransport: '',
        carrierTenantName: '',
        scene: '',
        createUserName: '',
        stationInfo: '',
        projectIds: '',
      };
      this.associationOdrNo = '';
      setTimeout(() => {
        const { creditCode } = this.$store.state.user;
        if (creditCode && this.$refs.serviceSelect) {
          this.$refs.serviceSelect.handleReset();
        }
      }, 100);
    },
    async getCargoType() {
      this.goodsCategory = await baseApi.getDictionary({
        status: 1,
        type: 'publicGoods',
      });
    },
    async getOrderList() {
      let reqData = this.filterEmptyKey(this.queryForm);
      let needTransport;
      if (reqData.needTransport === 1) {
        needTransport = true;
      } else if (reqData.needTransport === 0) {
        needTransport = false;
      }
      reqData = {
        queryField: {
          carrierTenantName: reqData.carrierTenantName,
          customerCode: reqData.customerCode,
          associationOdrNo: this.associationOdrNo,
          unifyNo: reqData.unifyOdrNo,
          crmNumber: reqData.crmNumber,
          skuName: reqData.skuName,
          needTransport,
          scene: reqData.scene,
          warehouseCode: reqData.warehouse,
          unifyStartTime: Number(reqData.createTime__BETWEEN[0]?.format('x')),
          unifyEndTime: Number(reqData.createTime__BETWEEN[1]?.format('x')),
          createUserName: reqData.createUserName,
          stationInfo: reqData.stationInfo,
          projectIds: reqData.projectIds ? [reqData.projectIds] : null,
        },
        status: reqData.status ? reqData.status.split(',') : '',
        sort: 'DESC',
      };
      const params = {
        size: this.pageSize,
        page: this.pagination.current,
      };
      this.isLoadingTable = true;
      try {
        const res = await fetchOrderList(reqData, params);
        this.orderRecords = res.records;
        this.pagination = {
          ...this.pagination,
          current: res.page,
          pageSize: res.size,
          total: res.total,
        };
      } finally {
        this.isLoadingTable = false;
      }
    },
    // 过滤掉空数组和空字符串
    // 比如 {name: 'mike', jobs: []} -> {name: 'mike'}
    filterEmptyKey(requestBody) {
      const newReqBody = Object.keys(requestBody).reduce((pre, key) => {
        const value = requestBody[key];
        const newData = pre;
        if (value !== null && value.length !== 0) {
          newData[key] = value;
        }
        return newData;
      }, {});
      return newReqBody;
    },

    deleteRecord(key) {
      this.dataSource = this.dataSource.filter((item) => item.key !== key);
      this.selectedRows = this.selectedRows.filter((item) => item.key !== key);
    },
    remove() {
      this.dataSource = this.dataSource.filter(
        (item) => this.selectedRows.findIndex((row) => row.key === item.key) === -1
      );
      this.selectedRows = [];
    },
    async handlePlaceOrder(e) {
      const { creditCode } = this.$store.state.user;
      if (!this.warehouseContract && !creditCode) {
        this.$message.warning('没有仓合同！');
        return;
      }
      if (e.key === PlaceOrderType.SINGLE) {
        this.$router.push({
          path: '/order/createOrder',
          query: {
            type: 'warehouse',
          },
        });
      }
      if (e.key === PlaceOrderType.MULTIPLE) {
        this.$router.push({
          path: '/order/create-multiple',
          query: {
            type: 'warehouse',
          },
        });
      }
    },
    formatFloatNum(num) {
      // eslint-disable-next-line no-nested-ternary
      return num === null ? '' : Number.isInteger(num) ? num : num.toFixed(4);
    },
  },
};
</script>

<style lang="less" scoped>
.OrderManageList-root {
  border: 0;
  .tag {
    display: inline-block;
    width: 20px;
    height: 20px;
    color: #fff;
    background: #e89d42;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    margin-right: 4px;
    margin-top: 4px;
    border-radius: 50%;
  }
  .success {
    background: #06b880;
    color: #fff;
    border: none;
  }
}
.operations-btns {
  text-align: right;
  margin-bottom: 20px;
}

.search-pane {
  padding: 24px;
  background-color: #fff;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.table-content {
  padding: 24px;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 6px;
}
// .btn-cancel {
//   margin-bottom: 12px;
// }
.form-row {
  // display: flex;
  // justify-content: space-between;
  .formTitle {
    text-align: right;
    padding-right: 16px;
    width: 100%;
    display: inline-block;
    color: #606266;
    font-size: 14px;
    line-height: 32px;
  }
}
.form-item:last-child {
  margin-right: 0;
}
.w-224 {
  // width: 224px;
  min-width: 150px;
  color: #171717;
}
.form-btns {
  display: flex;
  justify-content: flex-end;
  margin-right: 0;
  margin-top: 10px;
}
.form-btn {
  margin-left: 20px;
}
.address-txt {
  display: flex;
  align-items: center;
  > p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 4px;
    flex: 1;
  }
  span {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }
  .startStyle {
    background-color: #06b880;
  }
  .endStyle {
    background-color: #fb9432;
  }
}
.address-txt-min {
  width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.action-btn {
  padding: 0 8px;
  border-right: 1px solid rgba(0, 0, 0, 0.09);

  &:last-child {
    border-right: 0;
  }
}
.removeStyle {
  color: #969799;
}
.order-amount {
  color: #999999;
}
/deep/ .ant-tabs-tab-active {
  font-weight: bold !important;
}
/deep/ .ant-table-column-title {
  font-weight: bold;
}
.btnhidden {
  visibility: hidden;
}
.btnoverhidden {
  display: none;
}
.search-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.moreData {
  height: 30px;
  // width: 200px;
  line-height: 50px;
  background-color: #fff;
  font-size: 12px;
  // color: #06b880;
  &:hover {
    cursor: pointer;
  }
}
.nextForm {
  margin-top: 15px;
  transition: all ease 0.2s;
  // overflow: hidden;
}
.nextFormActive {
  height: auto;
}
.wai {
  display: inline-block;
  width: 18px;
  height: 18px;
  color: #000;
  border: 1px solid #ccc;
  background: #f5f5f5;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  margin-right: 4px;
  margin-top: 4px;
  border-radius: 50%;
}
/deep/ .ant-calendar-picker {
  // width: 250px !important;
  max-width: 100%;
}
.fontstyle {
  font-size: 12px;
  color: #999999;
}
.textLine {
  text-decoration: underline;
}
.noAuthority {
  text-align: center;
  color: #ccc;
  background: #fff;
  height: calc(100vh - 200px);
  line-height: calc(100vh - 200px);
}
.testStyle {
  font-size: 12px;
  color: #969799;
}
.divmaks {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  cursor: no-drop;
}
.search_btn {
  color: #06b880;
  border-color: #06b880;
}
.activeStyle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}
</style>
